import {
  PTAC_CUSTOM_TAG,
  PtacCustomSelectionPickType,
  PtacCustomSelectionType,
  PtacUnitPickType,
  SystemOptionType
} from 'data/types';
import { nanoid } from 'nanoid';
import { isPtacSelectedSystem } from 'utils/ptac-selected-system';

export const PTAC_CUSTOM_ID_PREFIX = 'ptac-custom-';

export function isPtacCustomOption(option: SystemOptionType): boolean {
  return isPtacSelectedSystem(option) && option.tags.includes(PTAC_CUSTOM_TAG);
}

export function ptacCustomSelectionId(): string {
  return `${PTAC_CUSTOM_ID_PREFIX}${nanoid(8)}`;
}

export function buildPtacCustomSelection({
  id,
  name,
  unitPicks,
  condenserUniqueId,
  productId
}: {
  id: string;
  name: string;
  unitPicks: PtacUnitPickType[];
  condenserUniqueId: string;
  productId: number;
}): PtacCustomSelectionType {
  const picks: PtacCustomSelectionPickType[] = unitPicks.map((pick) => ({
    condenserUniqueId: pick.condenserUniqueId,
    productId:
      pick.condenserUniqueId === condenserUniqueId
        ? productId
        : pick.product.productId
  }));
  return { id, name, picks };
}

export function ptacCustomSelectionsFromCompared(
  systemsToCompare: SystemOptionType[]
): PtacCustomSelectionType[] {
  return systemsToCompare.filter(isPtacCustomOption).map((option) => ({
    id: option.id,
    name: option.name,
    picks: option.configuration.condensers.map((condenser) => ({
      condenserUniqueId: condenser.uniqueId,
      productId: condenser.selectedProduct.productId
    }))
  }));
}

export function mergePtacCustomSelections(
  ...sources: PtacCustomSelectionType[][]
): PtacCustomSelectionType[] {
  const byId = new Map<string, PtacCustomSelectionType>();
  sources.flat().forEach((selection) => {
    if (!byId.has(selection.id)) byId.set(selection.id, selection);
  });
  return Array.from(byId.values());
}

export function ptacCustomSystemNames(options: SystemOptionType[]): string[] {
  return options.filter(isPtacCustomOption).map((option) => option.name);
}
